import React from 'react'

const Decorations = () => {
  const themes = [
    "🦄 Unicorn Magic", "🦸 Superhero", "👑 Princess", "🌴 Tropical",
    "🌸 Floral Garden", "✨ Bollywood", "🎬 Movie Theme", "🌟 Star Wars",
    "🏰 Vintage Royal", "🎨 Custom Theme"
  ]

  return (
    <section id="decorations" className="py-16 px-4 md:px-6">
      <div className="container mx-auto">
        <div className="section-bg">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold section-title-enhanced mb-6">
              🎨 Premium Decoration Services
            </h2>
            <p className="text-xl text-white max-w-3xl mx-auto leading-relaxed">
              Transform any venue into a breathtaking space with our expert decoration services, customized to match your theme and vision perfectly.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
            {/* Left Column */}
            <div className="space-y-6">
              <div className="card p-6">
                <h3 className="text-2xl font-bold mb-4 text-gray-800 flex items-center">
                  <i className="fas fa-palette text-[#1abc9c] mr-3"></i>
                  Occasion-Based Decorations
                </h3>
                <ul className="space-y-3 text-gray-700">
                  <li className="flex items-start">
                    <i className="fas fa-star text-[#f5576c] mt-1 mr-3"></i>
                    <span><strong>Birthday Decorations:</strong> Themed setups for kids & adults with balloon arches, backdrops, centerpieces</span>
                  </li>
                  <li className="flex items-start">
                    <i className="fas fa-star text-[#f5576c] mt-1 mr-3"></i>
                    <span><strong>Wedding Decorations:</strong> Mandap, stage, entrance, reception hall, floral arrangements, lighting</span>
                  </li>
                  <li className="flex items-start">
                    <i className="fas fa-star text-[#f5576c] mt-1 mr-3"></i>
                    <span><strong>Engagement Decorations:</strong> Romantic setups with flowers, drapes, chandeliers, and ambient lighting</span>
                  </li>
                  <li className="flex items-start">
                    <i className="fas fa-star text-[#f5576c] mt-1 mr-3"></i>
                    <span><strong>Baby Shower Decorations:</strong> Adorable themes with balloons, banners, photo corners, gift tables</span>
                  </li>
                  <li className="flex items-start">
                    <i className="fas fa-star text-[#f5576c] mt-1 mr-3"></i>
                    <span><strong>Function Decorations:</strong> Naming ceremonies, housewarming, anniversaries, festivals</span>
                  </li>
                </ul>
              </div>

              <div className="card p-6">
                <h3 className="text-2xl font-bold mb-4 text-gray-800 flex items-center">
                  <i className="fas fa-lightbulb text-[#1abc9c] mr-3"></i>
                  Specialized Decoration Elements
                </h3>
                <ul className="space-y-2 text-gray-700">
                  {["Balloon decorations & sculptures", "Floral arrangements & garlands", "Fabric draping & canopies", "LED & traditional lighting", "Entrance arches & walkways", "Theme-based props & backdrops"].map((item, idx) => (
                    <li key={idx} className="flex items-start">
                      <i className="fas fa-check text-[#1abc9c] mt-1 mr-3"></i>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {/* Right Column */}
            <div className="space-y-6">
              <div className="card p-6">
                <h3 className="text-2xl font-bold mb-4 text-gray-800 flex items-center">
                  <i className="fas fa-fire text-[#1abc9c] mr-3"></i>
                  Popular Decoration Themes
                </h3>
                <div className="grid grid-cols-2 gap-3 text-gray-700">
                  {themes.map((theme, idx) => {
                    const gradients = [
                      "from-[#f093fb]/20 to-[#f5576c]/20", "from-[#667eea]/20 to-[#764ba2]/20",
                      "from-[#fa709a]/20 to-[#fee140]/20", "from-[#4facfe]/20 to-[#00f2fe]/20",
                      "from-[#43e97b]/20 to-[#38f9d7]/20", "from-[#fa709a]/20 to-[#fee140]/20",
                      "from-[#667eea]/20 to-[#764ba2]/20", "from-[#f093fb]/20 to-[#f5576c]/20",
                      "from-[#4facfe]/20 to-[#00f2fe]/20", "from-[#43e97b]/20 to-[#38f9d7]/20"
                    ]
                    return (
                      <div key={idx} className={`p-3 bg-gradient-to-r ${gradients[idx]} rounded-lg`}>
                        <span className="font-semibold">{theme}</span>
                      </div>
                    )
                  })}
                </div>
              </div>

              <div className="card p-6 bg-gradient-to-r from-[#1abc9c]/10 to-[#16a085]/10">
                <h3 className="text-2xl font-bold mb-4 text-gray-800 flex items-center">
                  <i className="fas fa-trophy text-[#f5576c] mr-3"></i>
                  Why Choose Our Decorations?
                </h3>
                <ul className="space-y-3 text-gray-700">
                  {[
                    { title: "Customized Designs", desc: "Tailored to your vision and budget" },
                    { title: "Premium Quality", desc: "High-quality materials and execution" },
                    { title: "On-Time Setup", desc: "Punctual delivery and installation" },
                    { title: "Expert Team", desc: "Experienced decorators and designers" },
                    { title: "Complete Service", desc: "Setup to cleanup, we handle it all" }
                  ].map((item, idx) => (
                    <li key={idx} className="flex items-start">
                      <i className="fas fa-arrow-right text-[#1abc9c] mt-1 mr-3"></i>
                      <span><strong>{item.title}:</strong> {item.desc}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Decorations
